module.exports = __webpack_public_path__ + "static/img/map4.3874d97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/map4.png
// module id = AHTm
// module chunks = 0